import { css } from '@emotion/css'
import { colors } from 'settings/colors'

const invalid = css({ borderColor: colors.red })

export const getErrorStyle = () => {
  return invalid
}
